'use client';

import React__default, { useContext, useState, useEffect } from 'react';
import { SearchBarContext } from '../../context/reducer.js';
import { SearchBarBackground } from '../../SearchBar.css.js';
import { ACTIONS } from '../../context/actions.js';
import { EForceControDropdown } from '../../context/types.js';

var SearchBackground = function () {
    var _a = useContext(SearchBarContext), state = _a.state, dispatch = _a.dispatch;
    var isBlurBackground = state.isBlurBackground, isShow = state.isShow;
    var _b = useState(false), isMounted = _b[0], setMounted = _b[1];
    var onAnimationEnd = function () {
        if (isBlurBackground) {
            return;
        }
        setMounted(false);
    };
    useEffect(function () {
        if (!isBlurBackground) {
            return;
        }
        setMounted(true);
    }, [isBlurBackground]);
    return isMounted ? (React__default.createElement(SearchBarBackground, { "data-cname": 'SearchBackground', isShow: isBlurBackground, onClick: function () {
            if (isShow) {
                dispatch({
                    type: ACTIONS.FORCE_CONTROL,
                    payload: EForceControDropdown.CLOSE_ALL
                });
            }
        }, onAnimationEnd: onAnimationEnd })) : (React__default.createElement(React__default.Fragment, null));
};
var SearchBackground$1 = React__default.memo(SearchBackground);

export { SearchBackground$1 as default };
//# sourceMappingURL=index.js.map
